/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

import React, { useEffect, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { TModalTypes, ModalOuter } from "../../../components/Modal/ModalOuter"
import Spinner from "../../../components/Spinner"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import { AppDispatch } from "../../.."
import CONST from "../../../constant"
import { useDispatch } from "react-redux"
import TextInput from "../../../components/InputWrapper/TextInput"
import LabelFormRow from "../../../components/LabelFormRow"
import dayjs from "dayjs"
import EtcService from "../../../service/truckcontrol/Etc/etcService"
import {
  TETCDataGetListRes,
  TKohosya_1,
  TKohosya_2,
} from "../../../service/truckcontrol/Etc/TEtc"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
// import { setWarningAlerts } from "../../../globalStore/alertStore"
// import { Exception } from "@zxing/library"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import { setAlerts } from "../../../globalStore/alertStore"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faSearch } from "@fortawesome/free-solid-svg-icons"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import ZyomuinService from "../../../service/driver/zyomuinService"

/**
 * 乗務員 ETC紐づけモーダル
 * @param {*} props
 * @return {*} reactNode
 */
const EtcHimozukeModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title: string
    footer?: React.ReactNode
    gridId: string
    setChangeStateFlg: Function
    changeStateFlg: boolean
    候補者リスト?: TKohosya_1[]
    候補乗務員リスト_海コン?: TKohosya_2[]
    選択行?: TETCDataGetListRes
    ETC高速料id?: number
    setIsEdited: (value: boolean) => unknown
  }
> = (props) => {
  //#region [method]
  const beforeSubmit = () => {
    if (is乗務員直接選択モード) {
      if (!割当済乗務員_Id) {
        if (!割当済乗務員_社員コード) {
          // 乗務員の社員コードが未入力の場合
          setAlertSource({ warns: ["乗務員の社員CDが未入力です。"] })
        } else {
          // 無効な社員コードの場合
          setAlertSource({ warns: ["乗務員の社員CDが無効です。"] })
        }

        return
      }
    }
    setIsConfirmModalShow(true)
  }

  // 削除用
  const beforeDelete = () => {
    setIsDeleteConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      let data: {
        受注配車工程ID: number | undefined
        乗務員ID: number
      }

      if (受注配車選択行)
        data = {
          受注配車工程ID: 受注配車選択行!.受注配車工程ID,
          乗務員ID: 受注配車選択行!.乗務員ID,
        }
      else if (受注配車選択行2)
        data = {
          受注配車工程ID: 受注配車選択行2!.受注配車工程ID,
          乗務員ID: 受注配車選択行2!.乗務員ID,
        }
      else if (選択乗務員Id)
        data = {
          受注配車工程ID: undefined,
          乗務員ID: 選択乗務員Id,
        }
      else return

      let res = await new EtcService().putEtcHimoduke(
        props.選択行!.高速料ID.toString(),
        data
      )
      if (res) {
        showInfoToast(`ETC高速料の紐づけが完了しました`)
        props.setIsEdited(true)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
      props.setChangeStateFlg(false)
      props.setIsShow(false)
    }
  }

  const deleted = async () => {
    try {
      const data: { 乗務員ID: number } = { 乗務員ID: 0 }
      let res = await new EtcService().deleteHimoduke(
        props.選択行!.高速料ID.toString(),
        data
      )
      if (res) {
        showInfoToast(`ETC高速料の紐づけ削除が完了しました`)
        props.setIsEdited(true)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsDeleteConfirmModalShow(false)
      props.setChangeStateFlg(false)
      props.setIsShow(false)
    }
  }

  const clearInput = () => {
    set割当済乗務員_社員コード("")
    set割当済乗務員_氏名("")

    setAlertSource(undefined)
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<TETCDataGetListRes>) => {
    return new wjCore.CollectionView(data, {})
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createZyomuinCollectionView = (data: Array<TKohosya_1>) => {
    return new wjCore.CollectionView(data, {})
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createZyomuin2CollectionView = (data: Array<TKohosya_2>) => {
    return new wjCore.CollectionView(data, {})
  }

  //#endregion

  //#region [state]

  // 固定項目
  const [割当済乗務員_社員コード, set割当済乗務員_社員コード] =
    useState<string>()
  const [割当済乗務員_氏名, set割当済乗務員_氏名] = useState<string>()
  const [割当済乗務員_Id, set割当済乗務員_Id] = useState<number>()

  // Grid
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [zyomuinGridInitialized, setZyomuinGridInitialized] =
    useState<boolean>(false)
  const [zyomuin2GridInitialized, setZyomuin2GridInitialized] =
    useState<boolean>(false)

  // 固定Grid
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })
  const [pageSize, setPageSize] = useState<number>(10)

  // 乗務員選択Grid
  const [zyomuinFlexGrid, setZyomuinFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [zyomuinGridData, setZyomuinGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })
  const [pageSize2, setPageSize2] = useState<number>(10)

  // 乗務員選択Grid
  const [zyomuin2FlexGrid, setZyomuin2FlexGrid] = useState<wjcGrid.FlexGrid>()
  const [zyomuin2GridData, setZyomuin2GridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createCollectionView([]),
  })
  const [pageSize3, setPageSize3] = useState<number>(10)

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)
  const [isRestoreSearching2, setIsRestoreSearching2] = useState<boolean>(false)
  const [isRestoreSearching3, setIsRestoreSearching3] = useState<boolean>(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  const [選択乗務員Id, set選択乗務員Id] = useState<number>()
  const [受注配車選択行, set受注配車選択行] = useState<TKohosya_1>()
  const [受注配車選択行2, set受注配車選択行2] = useState<TKohosya_2>()
  const [is乗務員直接選択モード, setIs乗務員直接選択モード] =
    useState<boolean>(false)
  const [has選択行_紐付乗務員, setHas選択行_紐付乗務員] =
    useState<boolean>(false)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isDeleteConfirmModalShow, setIsDeleteConfirmModalShow] =
    useState(false)
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    if (props.isShow) {
      clearInput()
      setIsSearching(true)

      if (props.候補者リスト) {
        setZyomuinGridData({
          data: createZyomuinCollectionView(
            props.候補者リスト.sort((a, b) => {
              if (a.候補レベル !== b.候補レベル) return a.候補レベル - b.候補レベル
              if (a.受注配車工程ID > b.受注配車工程ID) return 1
              if (a.受注配車工程ID < b.受注配車工程ID) return -1
              return 0
            })
          ),
        })
      } else {
        setZyomuinGridData({ data: createCollectionView([]) })
      }

      if (props.候補乗務員リスト_海コン) {
        setZyomuin2GridData({
          data: createZyomuin2CollectionView(
            props.候補乗務員リスト_海コン.sort((a, b) => {
              if (a.候補レベル !== b.候補レベル) return a.候補レベル - b.候補レベル
              if (a.受注配車工程ID > b.受注配車工程ID) return 1
              if (a.受注配車工程ID < b.受注配車工程ID) return -1
              return 0
            })
          ),
        })
      } else {
        setZyomuin2GridData({ data: createCollectionView([]) })
      }

      setIs乗務員直接選択モード(
        (!props.候補者リスト || props.候補者リスト.length === 0) &&
          (!props.候補乗務員リスト_海コン ||
            props.候補乗務員リスト_海コン.length === 0)
      )

      // 選択行の乗務員IDが存在するかを設定
      setHas選択行_紐付乗務員(!!props.選択行?.乗務員ID)

      if (props.選択行) {
        const dataItem: TETCDataGetListRes[] = []
        dataItem.push(props.選択行)
        setGridData({ data: createCollectionView(dataItem) })
        flexGrid?.refresh()
        if (props.選択行.乗務員ID) {
          set割当済乗務員_社員コード(props.選択行.社員コード)
          set割当済乗務員_氏名(props.選択行.社員氏名)
        }
      }

      setIsSearching(false)
    } else {
      props.setChangeStateFlg(false)
    }
  }, [props.isShow])

  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      // リストア中フラグON
      setIsRestoreSearching(true)
    }
  }, [gridInitialized])

  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (zyomuinGridInitialized) {
      // リストア中フラグON
      setIsRestoreSearching2(true)
    }
  }, [zyomuinGridInitialized])

  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (zyomuin2GridInitialized) {
      // リストア中フラグON
      setIsRestoreSearching3(true)
    }
  }, [zyomuin2GridInitialized])

  useEffect(() => {
    if (!zyomuinFlexGrid) return
    const handler = (_s: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
      if (e.panel.cellType !== wjcGrid.CellType.Cell) return
      const item = e.panel.rows[e.row]?.dataItem as TKohosya_1
      const lv = item?.候補レベル
      if (lv === 1) e.cell.style.backgroundColor = '#ffe0b2'
      else if (lv === 2) e.cell.style.backgroundColor = '#fff3cd'
      else e.cell.style.backgroundColor = '#fffde7'
    }
    zyomuinFlexGrid.formatItem.addHandler(handler)
    return () => { zyomuinFlexGrid.formatItem.removeHandler(handler) }
  }, [zyomuinFlexGrid])

  useEffect(() => {
    if (!zyomuin2FlexGrid) return
    const handler = (_s: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
      if (e.panel.cellType !== wjcGrid.CellType.Cell) return
      const item = e.panel.rows[e.row]?.dataItem as TKohosya_2
      const lv = item?.候補レベル
      if (lv === 1) e.cell.style.backgroundColor = '#ffe0b2'
      else if (lv === 2) e.cell.style.backgroundColor = '#fff3cd'
      else e.cell.style.backgroundColor = '#fffde7'
    }
    zyomuin2FlexGrid.formatItem.addHandler(handler)
    return () => { zyomuin2FlexGrid.formatItem.removeHandler(handler) }
  }, [zyomuin2FlexGrid])

  //#endregion

  //#region [async functions]

  //useEffect内ではasyncが使用できないため外部に記述
  const 乗務員取得 = async (社員コード?: string) => {
    setAlertSource(undefined)
    if (社員コード == null || wjCore.isNullOrWhiteSpace(社員コード ?? "")) {
      clear乗務員情報()
      return
    }
    try {
      const 乗務員res = await new ZyomuinService().getList({
        部所コード: "",
        退職フラグ: 0,
        社員コード,
      })

      if (乗務員res != null && 乗務員res.data.length > 0) {
        const 乗務員 = 乗務員res.data[0]
        // serviceが前方一致でデータ取得しているので、社員コードの一致後に氏名をとる
        if (乗務員.社員コード === 社員コード && 乗務員.退職フラグ === 0) {
          set割当済乗務員_Id(乗務員.乗務員ID)
          set割当済乗務員_氏名(乗務員.社員氏名)
          set割当済乗務員_社員コード(乗務員.社員コード)
        } else {
          setAlertSource({ infos: ["社員CDに該当する乗務員がいません。"] })
          clear乗務員情報()
        }
      } else {
        setAlertSource({ infos: ["社員CDに該当する乗務員がいません。"] })
        clear乗務員情報()
      }
    } catch (error) {
      setAlertSource(error)
    }
  }

  const 乗務員社員コード打鍵 = (社員コード?: string) => {
    setAlertSource(undefined)
    if (社員コード == null || wjCore.isNullOrWhiteSpace(社員コード ?? "")) {
      clear乗務員情報()
      return
    }
  }

  const clear乗務員情報 = () => {
    set割当済乗務員_Id(undefined)
    set割当済乗務員_氏名("")
    set割当済乗務員_社員コード("")
  }

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title}
      setIsShow={props.setIsShow}
      size={"xl"}>
      <Spinner inModal searching={isSearching}></Spinner>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Header>ETCデータ</Card.Header>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={1}
                  gridId={`${props.gridId}_1`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  isShowGridRowPickupButton={false}
                  hasFilter={false}
                  isShowGridFooter={false}
                  headerComponent={
                    props.選択行?.乗務員ID && (
                      <>
                        <Button
                          type="submit"
                          className="btn-danger"
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            // TODO:削除用のservice呼ぶ？
                            beforeDelete()
                          }}>
                          紐づけ削除
                        </Button>
                      </>
                    )
                  }>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="車番"
                    width={100}
                    header="車番"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="ETCカード番号"
                    width={180}
                    header="ETC番号"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="日付"
                    width={100}
                    wordWrap={true}
                    header="日付">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TETCDataGetListRes>
                      ) => {
                        let dt = ""
                        if (context.item.日付)
                          dt = dayjs(context.item.日付).format("YYYY/MM/DD")
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="時刻"
                    width={80}
                    header="時刻"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="利用IC自"
                    width={128}
                    header="利用IC_自"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="利用IC至"
                    width={128}
                    header="利用IC_至"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="金額"
                    width={128}
                    format="n"
                    header="金額"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <form>
          <Row className="mb-4">
            <Col>
              <div className="d-flex">
                <LabelFormRow
                  label="割当済乗務員"
                  positionClassName="d-flex"
                  labelWidth={5}
                  formWidth={25}
                  Width={30}>
                  <TextInput
                    style={{ width: "6rem" }}
                    id="割当済乗務員コード"
                    name="割当済乗務員コード"
                    value={割当済乗務員_社員コード}
                    setValue={set割当済乗務員_社員コード}
                    autoFocus={is乗務員直接選択モード && !has選択行_紐付乗務員}
                    isReadOnly={
                      !(is乗務員直接選択モード && !has選択行_紐付乗務員)
                    }
                    onBlur={async (e) => {
                      const v = e.currentTarget.value
                      乗務員取得(v)
                    }}
                    onChange={async (e) => {
                      const v = e.currentTarget.value
                      乗務員社員コード打鍵(v)
                    }}
                    placeholder="社員CD"
                  />
                  <button
                    type="button"
                    className="icon-button"
                    hidden={!is乗務員直接選択モード || has選択行_紐付乗務員}
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      setIs乗務員検索Modal(true)
                    }}>
                    <FontAwesomeIcon
                      className="icon-button-inner"
                      icon={faSearch}></FontAwesomeIcon>
                  </button>

                  <TextInput
                    style={{ width: "13rem" }}
                    id="割当済乗務員"
                    name="割当済乗務員"
                    value={割当済乗務員_氏名}
                    isReadOnly={true}
                    setValue={set割当済乗務員_氏名}
                    tabIndex={-1}
                  />

                  <Button
                    className="btn btn-primary move-edit-page ms-4 align-middle"
                    disabled={!is乗務員直接選択モード || has選択行_紐付乗務員}
                    hidden={!is乗務員直接選択モード || has選択行_紐付乗務員}
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      // ModalShow
                      set受注配車選択行(undefined)
                      set受注配車選択行2(undefined)
                      set選択乗務員Id(割当済乗務員_Id)
                      beforeSubmit()
                    }}>
                    割当
                  </Button>
                </LabelFormRow>
              </div>
            </Col>
          </Row>
        </form>
        <Row>
          <Col>
            <Card>
              <Card.Header>通常貨物</Card.Header>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={zyomuinFlexGrid}
                  setFlexGrid={setZyomuinFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={zyomuinGridData}
                  setGridData={setZyomuinGridData}
                  pageNumber={1}
                  gridId={`${props.gridId}_2`}
                  isRestoreSearching={isRestoreSearching2}
                  setIsRestoreSearching={setIsRestoreSearching2}
                  gridInitialized={zyomuinGridInitialized}
                  setGridInitialized={setZyomuinGridInitialized}
                  pageSize={pageSize2}
                  setPageSize={setPageSize2}
                  isShowGridRowPickupButton={false}
                  hasFilter={false}
                  isShowGridFooter={false}>
                  <wjrGrid.FlexGridColumn
                    header="選択"
                    align="center"
                    width={80}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKohosya_1>
                      ) => {
                        if (!props.選択行?.受注配車工程ID) {
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                // ModalShow
                                set受注配車選択行(context.item)
                                beforeSubmit()
                              }}>
                              選択
                            </Button>
                          )
                        } else if (
                          context.item.受注配車工程ID ===
                          props.選択行?.受注配車工程ID
                        ) {
                          return <FontAwesomeIcon icon={faCheck} />
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="候補レベル"
                    width={40}
                    header="LV"
                    align="center"
                    isReadOnly></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="社員コード"
                    width={60}
                    header="CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="乗務員名"
                    width={128}
                    header="乗務員名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="荷主名"
                    width={150}
                    header="荷主"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="積日"
                    width={100}
                    wordWrap={true}
                    header="積日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKohosya_1>
                      ) => {
                        let dt = ""
                        if (context.item.積日)
                          dt = dayjs(context.item.積日).format("YYYY/MM/DD")
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="卸日"
                    width={100}
                    wordWrap={true}
                    header="卸日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKohosya_1>
                      ) => {
                        let dt = ""
                        if (context.item.卸日)
                          dt = dayjs(context.item.卸日).format("YYYY/MM/DD")
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="コース編集"
                    width={400}
                    header="コース"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Header>海上コンテナ</Card.Header>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={zyomuin2FlexGrid}
                  setFlexGrid={setZyomuin2FlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={zyomuin2GridData}
                  setGridData={setZyomuin2GridData}
                  pageNumber={1}
                  gridId={`${props.gridId}_3`}
                  isRestoreSearching={isRestoreSearching3}
                  setIsRestoreSearching={setIsRestoreSearching3}
                  gridInitialized={zyomuin2GridInitialized}
                  setGridInitialized={setZyomuin2GridInitialized}
                  pageSize={pageSize3}
                  setPageSize={setPageSize3}
                  isShowGridRowPickupButton={false}
                  hasFilter={false}
                  isShowGridFooter={false}>
                  <wjrGrid.FlexGridColumn
                    header="選択"
                    align="center"
                    width={80}
                    selectable={false}
                    isReadOnly>
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKohosya_2>
                      ) => {
                        if (!props.選択行?.受注配車工程ID) {
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              onClick={(e) => {
                                // ModalShow
                                set受注配車選択行2(context.item)
                                beforeSubmit()
                              }}>
                              選択
                            </Button>
                          )
                        } else if (
                          context.item.受注配車工程ID ===
                          props.選択行?.受注配車工程ID
                        ) {
                          return <FontAwesomeIcon icon={faCheck} />
                        } else {
                          return <></>
                        }
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="候補レベル"
                    width={40}
                    header="LV"
                    align="center"
                    isReadOnly></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="社員コード"
                    width={60}
                    header="CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="乗務員名"
                    width={128}
                    header="乗務員名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="荷主名"
                    width={150}
                    header="荷主"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="積卸日"
                    width={100}
                    wordWrap={true}
                    header="作業日">
                    <wjrGrid.FlexGridCellTemplate
                      cellType="Cell"
                      template={(
                        context: TWijmoCellTemplateContext<TKohosya_2>
                      ) => {
                        let dt = ""
                        if (context.item.積卸日)
                          dt = dayjs(context.item.積卸日).format("YYYY/MM/DD")
                        return <>{dt}</>
                      }}
                    />
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="工程区分名称1"
                    width={100}
                    wordWrap={true}
                    header="工程"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    cssClass="read-only-cell"
                    binding="コース編集"
                    width={400}
                    header="コース"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          set割当済乗務員_社員コード(乗務員.社員コード)
          set割当済乗務員_Id(乗務員.乗務員ID)
          set割当済乗務員_氏名(乗務員.社員氏名)
        }}></ZyomuinSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteConfirmModalShow}
        hideHandler={setIsDeleteConfirmModalShow}
        submitHandler={deleted}>
        ETC紐づけを削除しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default EtcHimozukeModal
